<div class="">
  <h1 class="title">
    {{
      type === "candidat"
        ? "Créez votre compte candidat"
        : "Créez votre compte d'établissement"
    }}
  </h1>
  <h5 class="title-text-muted text-muted fs-16">
    Créez votre compte d'établissement. Dans cette première fenêtre, saisissez
    les données de la personne qui crée le compte.
  </h5>
  <div class="row my-2 align-items-end">
    <div class="col-3">
      <app-custom-drop-down
        [parentForm]="firstStepFormControl"
        controlName="prefixe"
        class="prefixe-class"
        [label]="'Civilité'"
        [options]="civilityOptions"
        [required]="true"
        [simpleDropDown]="true"
      ></app-custom-drop-down>
    </div>
    <div class="col">
      <app-custom-input
        [parentForm]="firstStepFormControl"
        controlName="firstName"
        [label]="type === 'candidat' ? 'Votre Nom' : 'Nom'"
        [required]="true"
      ></app-custom-input>
    </div>
    <div class="col">
      <app-custom-input
        [parentForm]="firstStepFormControl"
        controlName="lastName"
        [label]="type === 'candidat' ? 'Votre Prénom' : 'Prénom'"
        [required]="true"
      ></app-custom-input>
    </div>
  </div>
  
  <div class="row my-3">
    <app-custom-input
      [parentForm]="firstStepFormControl"
      controlName="email"
      [label]="
        type !== 'candidat'
          ? 'Votre adresse e-mail de connexion'
          : 'Votre adresse e-mail'
      "
      [placeholder]="'ex: jacques.dupon@company.com'"
      [type]="'email'"
      [required]="true"
    ></app-custom-input>
  </div>
  <div class="row my-3">
    <app-custom-input
      [parentForm]="firstStepFormControl"
      controlName="password"
      [label]="
        type === 'candidat'
          ? 'Choisissez votre mot de passe'
          : 'Votre mot de passe'
      "
      [type]="'password'"
      positionIcon="right"
      [required]="true"
    ></app-custom-input>
    <div
      class="fs-11 my-px-5"
      [ngClass]="{
        required: firstStepFormControl.get('password')?.dirty,
        'text-secondary': !firstStepFormControl.get('password')?.dirty
      }"
    >
      <span [ngClass]="{ 'text-success': passwordFormField?.match('.{8,}') }"
        >Le mot de passe doit contenir au moins 8 caractères</span
      >,
      <span
        [ngClass]="{ 'text-success': passwordFormField?.match('^(?=.*[A-Z])') }"
        >dont une lettre majuscule</span
      >,
      <span
        [ngClass]="{ 'text-success': passwordFormField?.match('(?=.*[a-z])') }"
        >une lettre minuscule</span
      >,
      <span
        [ngClass]="{ 'text-success': passwordFormField?.match('(.*[0-9].*)') }"
      >
        un chiffre</span
      >
      <span
        [ngClass]="{
          'text-success': passwordFormField?.match('(?=.*[!@#$%^&*/])')
        }"
      >
        et un caractère spécial</span
      >
      .
    </div>
  </div>
  <div class="row my-3">
    <app-custom-checkbox
      [formGroup]="firstStepFormControl"
      controlName="confirmBtn"
      [label]="
        type !== 'candidat'
          ? 'Je confirme avoir lu et accepté les conditions générales d’utilisation '
          : 'Je confirme avoir lu et accepté les conditions générales d’utilisation. '
      "
    ></app-custom-checkbox>
  </div>
  <div class="row my-3">
    <app-button
      color="primary"
      (handleClick)="nextStep()"
      [disabled]="firstStepFormControl.invalid || loading"
      text="Créer mon compte professionnel et continuer"
      class="mx-auto text-center"
      [innerClass]="'p-3 w-100'"
    ></app-button>
  </div>
  <h5 class="title-text-muted text-muted">
    {{
      type === "candidat"
        ? "Vous êtes plutôt un établissement de santé et vous cherchez à recruter des professionnels de santé?"
        : "Vous êtes plutôt un professionnel de santé et vous cherchez des missions?"
    }}
    <a
      (click)="changeType()"
      [routerLink]="[
        type === 'candidat' ? '/register/etablissement' : '/register/candidat'
      ]"
      class="text-decoration-none"
    >
      {{
        type === "candidat"
          ? "Créer un compte établissement"
          : "Créer un compte candidat"
      }}
    </a>
  </h5>
</div>
<!--Vous êtes plutôt un établissement de santé et vous cherchez à recruter des professionnels de santé? -->
